import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { M2IssuersEdit } from "./edit";
import { M2IssuersNew } from "./new";
import { M2IssuersTable } from "./table";

export default function M2Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Issuers");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<M2IssuersNew />} />
      <Route path=":id" element={<M2IssuersEdit />} />
      <Route index element={<M2IssuersTable />} />
    </Routes>
  );
}
